<template>
    <DetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes"
        :back_href="'/associates'"
        :items="cache_associates"
        :label_key="'associate_name'"
        :next="next"
        :previous="previous"
        :show_next_previous_buttons="true"
        :label_key_id="'id'"
    /> 
</template>


<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import DetailComponent  from    '@/components/DetailComponent/DetailComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'AssociateDetail',
    components: {
        DetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            rest_api:           `associates/${this.$route.params.id}`,
            rest_api_note:      `associate_notes`,
            form_format:        FormResources.form_main_format,
            breadcrumb:         Resources.breadcrumb,
            title_page:         '',
            content_header:     this.$store.state.headers,
            single_object:      {},
            array_options:      {
                give_access_to: []
            },
            shift_options:      FormResources.shift_options,
            associates_selected:   [],
            associate_counter: 0,
            cache_associates: [],
            next: null,
            previous: null
        }
    },

    methods:{
        changeValidationReportsTo(param)
        {
            this.form_format[10].disabled = !param
            this.form_format[10].required = param

            this.form_format[10].disabled = param
            this.form_format[10].required = !param
        },

        fill_data(data) 
        {
            this.single_object  = data.associate;
            this.associates_selected = data.associates.map((item) => { return { id: item.ref, name: `${item.first_name} ${item.last_name}`, role_id: item.role_id } })
            this.cache_associates = data.cache_associates
            this.next = data.next
            this.previous = data.previous

            this.array_options = {
                cost_center_department_id:  data.departments,
                position_id:                data.positions,
                territory_id:               data.countries,
                contract_type_id:           data.contract_types,
                shift:                      this.shift_options,
                role_id:                    data.roles,
                permissions_template_id:    data.permissions_templates,
                give_access_to:             data.facilities
            }
            
            this.title_page     = `${this.single_object.first_name} ${this.single_object.last_name}`;
            this.breadcrumb[1].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   `${this.single_object.first_name} ${this.single_object.last_name}`,
                href:   '#',
                arrow:  " ",
            });
        },

    },
    watch: {
       async  "single_object.role_id"(val)
        {
            if(val)
            {
                
                    
                this.loader(true)
                
                const response = await this.post('reports_to_by_roles', {rol: val, id: this.single_object.id})

                if(response.status)
                {
                    this.array_options.report_associate_id = response.data.associates

                    if(response.data.should_report)
                    {
                        this.changeValidationReportsTo(false)

                        let found_associate =  this.array_options['report_associate_id'].findIndex(item => item.id === this.single_object.report_associate_id)

                        if(found_associate < 0)
                        {
                            this.single_object.report_associate_id = ''
                        }
                    }
                    else
                    {
                        this.changeValidationReportsTo(true)
                        this.single_object.report_associate_id = ''
                    }
                }

                this.loader()
            }
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['Associate Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    }
}
</script>